import { Button, Card, Grid2, Typography } from "components";
import { Edit1Icon } from "components/Icons";
import dayjs from "dayjs";
import { useState } from "react";
import { INDIA_STATES } from "utils/constants";
import RevenueModal from "./RevenueModal";

interface Props {
  revenueData: any;
  revenueRefetch: () => void;
}

const Revenue = (props: Props) => {
  const { revenueData, revenueRefetch } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={2.2}>
        <Card sx={{ p: 1.5, background: "var(--neutral-50)" }}>
          <Grid2 container alignItems="center" justifyContent="space-between">
            <Grid2>
              <Typography fontSize={12} fontWeight={500}>
                Amc Charges:
              </Typography>
              <Typography
                fontSize={15}
                fontWeight={500}
                color="var(--primary-900)"
              >
                {revenueData?.data?.data?.amcCharges || "-"}
              </Typography>
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>
      <Grid2 size={2.2}>
        <Card sx={{ p: 1.5, background: "var(--neutral-50)" }}>
          <Grid2 container alignItems="center" justifyContent="space-between">
            <Grid2>
              <Typography fontSize={12} fontWeight={500}>
                Portfolio Limit:
              </Typography>
              <Typography
                fontSize={15}
                fontWeight={500}
                color="var(--primary-900)"
              >
                {revenueData?.data?.data?.portfolioLimit || "-"}
              </Typography>
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>
      <Grid2 size={2.2}>
        <Card sx={{ p: 1.5, background: "var(--neutral-50)" }}>
          <Grid2 container alignItems="center" justifyContent="space-between">
            <Grid2>
              <Typography fontSize={12} fontWeight={500}>
                Per Portfolio Charges:
              </Typography>
              <Typography
                fontSize={15}
                fontWeight={500}
                color="var(--primary-900)"
              >
                {revenueData?.data?.data?.perPortfolioCharges || "-"}
              </Typography>
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>
      <Grid2 size={2.2}>
        <Card sx={{ p: 1.5, background: "var(--neutral-50)" }}>
          <Grid2 container alignItems="center" justifyContent="space-between">
            <Grid2>
              <Typography fontSize={12} fontWeight={500}>
                First Billing Date:
              </Typography>
              <Typography
                fontSize={15}
                fontWeight={500}
                color="var(--primary-900)"
              >
                {revenueData?.data?.data?.renewalDate
                  ? dayjs(revenueData?.data?.data?.renewalDate).format(
                      "DD-MM-YYYY"
                    )
                  : "-"}
              </Typography>
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>
      <Grid2 size={2.2}>
        <Card sx={{ p: 1.5, background: "var(--neutral-50)" }}>
          <Grid2 container alignItems="center" justifyContent="space-between">
            <Grid2>
              <Typography fontSize={12} fontWeight={500}>
                State:
              </Typography>
              <Typography
                fontSize={15}
                fontWeight={500}
                color="var(--primary-900)"
              >
                {INDIA_STATES?.find(
                  (s) => s.name === revenueData?.data?.data?.state
                )?.name ||
                  revenueData?.data?.data?.state ||
                  "-"}
              </Typography>
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>
      <Grid2 container justifyContent="flex-end" alignItems="center">
        <Button variant="secondaryDark" onClick={() => setIsModalOpen(true)}>
          <Edit1Icon fontSize="small" />
        </Button>
      </Grid2>

      {isModalOpen && (
        <RevenueModal
          open={isModalOpen}
          setOpen={setIsModalOpen}
          revenueData={revenueData?.data?.data}
          refetch={revenueRefetch}
        />
      )}
    </Grid2>
  );
};

export default Revenue;
